import { format, parseISO } from 'date-fns'
import React from 'react'
import { connect } from 'react-redux'
import { Config } from '@chegg-wt/core/config'
import { userClick } from '@chegg-wt/core/state/instrumentation/actions'
import { Dispatch } from 'redux'
import { origins } from '@chegg-wt/core/state/instrumentation/rio/clickstreamInteractions'
import { PAPER_ITEM } from '../utils/testIds'
import AppLink from '../../AppLink'
import {
  ListItemLink,
  ListItemName,
  ListItemDateText,
} from '../../BaseProjectList/styled'

export interface PaperListItemDispatchProps {
  onUserClick: () => void
}

export interface PaperListItemOwnProps {
  uploadUuid: string
  index: number
  name: string
  date: string
}

type PaperListItemProps = PaperListItemDispatchProps & PaperListItemOwnProps

const PaperListItem: React.FC<PaperListItemProps> = ({
  uploadUuid,
  index,
  name,
  date,
  onUserClick,
}) => {
  const handleClick = () => {
    onUserClick()
  }
  return (
    <AppLink route={{ href: `${Config.writingUrl}/edit/${uploadUuid}` }}>
      <ListItemLink data-test={`${PAPER_ITEM}_${index}`} onClick={handleClick}>
        <ListItemName>{name}</ListItemName>
        <ListItemDateText>
          Updated: {format(parseISO(date), 'MM/dd/yyyy')}
        </ListItemDateText>
      </ListItemLink>
    </AppLink>
  )
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onUserClick: () => dispatch(userClick({ origin: origins.dashboardClickPaper })),
})

export default connect<{}, PaperListItemDispatchProps>(
  null,
  mapDispatchToProps
)(PaperListItem)
